<div class="main__container">

	<breadcrumb title="Correos Electrónicos"></breadcrumb>

	<div class="section__container">
		<div class="box__container titulo__container">
			<div class="titulo">
				<div>
					<div>Correos Electrónicos</div>
					<ng-container *ngIf="{ personal: filteredPersonal$ | async, delegados: filteredDelegados$ | async } as email">
						<div *ngIf="( email.personal? 1: 0 ) + ( email.delegados? email.delegados.length: 0 ) as cantidad" class="cantidad__apps">
							{{ cantidad }}
							<ng-container *ngIf="cantidad == 1">correo</ng-container>
							<ng-container *ngIf="cantidad != 1">correos</ng-container>
							con acceso
						</div>
					</ng-container>
				</div>
				<div class="filter__container">
					<input #appFilter type="text" class="filter" placeholder="Buscador de correos electrónicos">
					<div class="search__button"></div>
				</div>
			</div>
		</div>

		<div class="contenido__box">
			<div class="contenido__container">
				<div *ngIf="{ personal: filteredPersonal$ | async, delegados: filteredDelegados$ | async } as email">
					<ng-container *ngIf="email.personal">
						<div class="cuenta__titulo">Cuenta Personal</div>
						<div class="acceso__container">
							<ng-container [ngTemplateOutlet]="cardPersonal" [ngTemplateOutletContext]="{ acceso: email.personal }"></ng-container>
						</div>
					</ng-container>

					<hr *ngIf="email.personal && email.delegados && email.delegados.length > 0">

					<ng-container *ngIf="email.delegados && email.delegados.length > 0">
						<div class="cuenta__titulo">Cuentas Institucionales</div>

						<div class="acceso__container">
							<ng-container *ngFor="let delegado of email.delegados, let isLast = last">
								<ng-container [ngTemplateOutlet]="cardDelegado" [ngTemplateOutletContext]="{ acceso: delegado }"></ng-container>
								<div *ngIf="!isLast" class="sep"></div>
							</ng-container>
						</div>

					</ng-container>
				</div>
			</div>
		</div>
	</div>

</div>

<ng-template #cardPersonal let-acceso="acceso">
	<div class="icon personal-icon"></div>
	<div class="desc">{{acceso.emailAbreviado}}</div>
	<div><button class="btn ingresar" [ngStyle]="getEmailStyle()" (click)="openEmailPersonal( acceso )">Ingresar</button></div>
	<div class="marked"></div>
</ng-template>

<ng-template #cardDelegado let-acceso="acceso">
	<div class="icon delegado-icon"></div>
	<div class="desc">{{acceso.emailAbreviado}}</div>
	<div><button class="btn ingresar" [ngStyle]="getEmailStyle()" (click)="openEmailDelegado( acceso )">Ingresar</button></div>
	<ng-container *ngIf="acceso.ready == null || acceso.ready">
		<div class="marked" [ngClass]="{ 'marked-on': acceso.marked, 'marked-off': !acceso.marked }" (click)="onToggleMark( acceso )" [gtagLabel]="acceso.nombre" [gtagEvent]="acceso.marked? 'desmarcar-favorito': 'marcar-favorito'" gtagCategory="correo-electronico"></div>
	</ng-container>
	<ng-container *ngIf="acceso.ready != null && !acceso.ready">
		<div class="marked" [ngClass]="{ 'marked-on': acceso.marked, 'marked-off': !acceso.marked, working: true }" (click)="onToggleMark( acceso )"></div>
	</ng-container>
</ng-template>
